import Ajax from './components/Ajax';
import Newspagination from "./ajax/Newspagination";

let ajaxObj = new Ajax();
const newsPaginationObj = new Newspagination(ajaxObj);